<template>
        <div id="list-conjuntos-page">
                <div class="vx-row">
                        <div class="vx-col w-full">
                                <vx-card title="Conjuntos que administras">
                                        <div slot="no-body" class="mt-4">
                                                <vs-table :data="conjuntos">
                                                        <template slot="thead">
                                                                <vs-th class="w-1/5">ID DE CONJUNTO</vs-th>
                                                                <vs-th class="w-1/4">NOMBRE</vs-th>
                                                                <vs-th>DIRECCION</vs-th>
                                                                <vs-th>NIT</vs-th>
                                                                <vs-th>TELEFONO</vs-th>
                                                                <vs-th>EMAIL</vs-th>
                                                                <vs-th></vs-th>
                                                        </template>

                                                        <template slot-scope="{ data }">
                                                                <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                                                                        <vs-td :data="data[indextr].id">
                                                                                <span class="w-1/5">{{
                                                                                        data[indextr].id.substr(-12, 12)
                                                                                }}</span>
                                                                        </vs-td>
                                                                        <vs-td :data="data[indextr].id">
                                                                                <span class="w-1/4">{{
                                                                                        data[indextr].nombre
                                                                                }}</span>
                                                                        </vs-td>
                                                                        <vs-td :data="data[indextr].id">
                                                                                <span>{{
                                                                                        data[indextr].calle +
                                                                                                ' ' +
                                                                                                data[indextr].numero
                                                                                }}</span>
                                                                        </vs-td>
                                                                        <vs-td :data="data[indextr].id">
                                                                                <span>{{ data[indextr].nit }}</span>
                                                                        </vs-td>
                                                                        <vs-td :data="data[indextr].id">
                                                                                <span>{{
                                                                                        data[indextr].telefono
                                                                                }}</span>
                                                                        </vs-td>
                                                                        <vs-td :data="data[indextr].id">
                                                                                <span>{{ data[indextr].email }}</span>
                                                                        </vs-td>
                                                                        <vs-td :data="data[indextr].id">
                                                                                <vs-button
                                                                                        color="primary"
                                                                                        type="flat"
                                                                                        icon-pack="FA5"
                                                                                        icon="far fa-edit"
                                                                                        >Editar</vs-button
                                                                                >
                                                                        </vs-td>
                                                                </vs-tr>
                                                        </template>
                                                </vs-table>
                                        </div>
                                </vx-card>
                        </div>
                </div>
        </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
        data() {
                return {
                        isDisabled: false,
                };
        },
        computed: {
                ...mapState(['conjuntos']),
        },
        mounted() {
                this.checkDisabled;
        },
};
</script>
